// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"198":"31b33079","703":"411af354"}[chunkId] + ".chunk.js";
};